"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var react_1 = __importStar(require("react"));
var Tabs_1 = __importDefault(require("./Tabs"));
var RepeatedTabs_1 = __importDefault(require("./RepeatedTabs"));
var LeaderBoard_1 = __importDefault(require("./LeaderBoard"));
var TournamentPrizes_1 = __importDefault(require("./TournamentPrizes"));
var Conditions_1 = __importDefault(require("./Conditions"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TableWithResults = function (_a) {
    var _b, _c, _d;
    var tournament = _a.tournament, isFinished = _a.isFinished;
    var _e = (0, react_1.useState)(1), activeTab = _e[0], setActiveTab = _e[1];
    var onClickHandler = function (idx) {
        setActiveTab(idx);
    };
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(Tabs_1.default, { onClickHandler: onClickHandler, activeTab: activeTab }),
        activeTab === 0 && (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(ui_components_1.LoadingWithContainer, null) },
            react_1.default.createElement(LeaderBoard_1.default, { topPlayers: (tournament === null || tournament === void 0 ? void 0 : tournament.topScores) || [], tournamentPosition: tournament === null || tournament === void 0 ? void 0 : tournament.me }))),
        activeTab === 1 && (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(ui_components_1.LoadingWithContainer, null) },
            react_1.default.createElement(TournamentPrizes_1.default, { prizes: (_b = tournament === null || tournament === void 0 ? void 0 : tournament.baseTournament) === null || _b === void 0 ? void 0 : _b.rewards, userConfirmed: !!(tournament === null || tournament === void 0 ? void 0 : tournament.me), tournamentId: tournament === null || tournament === void 0 ? void 0 : tournament.id, isFinished: isFinished }))),
        activeTab === 2 && (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(ui_components_1.LoadingWithContainer, null) },
            react_1.default.createElement(Conditions_1.default, { description: (_d = (_c = tournament === null || tournament === void 0 ? void 0 : tournament.baseTournament) === null || _c === void 0 ? void 0 : _c.descriptions) === null || _d === void 0 ? void 0 : _d.long, userConfirmed: !!(tournament === null || tournament === void 0 ? void 0 : tournament.me), tournamentId: tournament === null || tournament === void 0 ? void 0 : tournament.id, isFinished: isFinished }))),
        react_1.default.createElement(RepeatedTabs_1.default, { onClickHandler: onClickHandler, activeTab: activeTab })));
};
exports.default = TableWithResults;
